package link.erpango.quip.ui.transfer

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier

/**
 * JS/Web-specific QR scanner implementation (fallback to manual input).
 */
actual object PlatformQrScanner : QrScannerContract {
    
    @Composable
    actual override fun QrScannerView(
        modifier: Modifier,
        onQrScanned: (String) -> Unit,
        onError: (String) -> Unit
    ) {
        Box(modifier = modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
            Text("Escaneo con cámara no disponible en Web. Usa el input manual.")
        }
    }
}
